import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper">
      <div className="px-6 md:px-12 pt-12 md:pt-16 pb-6">
        <FadeUp className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <p className="font-serif font-light text-2xl md:text-3xl tracking-tight whitespace-nowrap">
            Every project begins with a conversation.
          </p>
          <Link
            to="/inquiries"
            data-testid="footer-inquiry-cta"
            className="group inline-flex items-center gap-3 border border-paper/60 px-7 py-3.5 text-sm tracking-[0.08em] hover:bg-paper hover:text-ink transition-colors duration-400 shrink-0"
          >
            Start an Inquiry
            <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </FadeUp>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mt-12 md:mt-16 pt-7 border-t border-paper/15 text-[11px] uppercase tracking-[0.25em] text-paper/40">
          <span>© {new Date().getFullYear()} Medium Plenty</span>
          <div className="flex items-center gap-6">
            <ap-badge
              href="https://archiproamerica.com/professional/medium-plenty"
              theme="white"
              size="110"
              transparent={true}
            />
            <a
              data-testid="footer-instagram-icon"
              href="https://www.instagram.com/mediumplenty/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Medium Plenty on Instagram"
              className="text-paper/60 hover:text-paper transition-colors duration-300"
            >
              <Instagram size={18} strokeWidth={1.5} />
            </a>
          </div>
          <span>Architecture + Interiors</span>
        </div>
      </div>
    </footer>
  );
}
